// extracted by mini-css-extract-plugin
export default {"wrapper":"lE-z","viewport":"mE-z","container":"nE-z","slide":"oE-z"};